import AppSettings from "src/AppSettings";
import type { AppIconDefinition } from "src/components/common/Icon";
import type { ILayoutLink } from "src/contexts/layouts/LayoutContext";

const iconsByLabel: Record<string, AppIconDefinition> = {
    "All Items": AppSettings.icons.models.item,
    "Administration Case Report": AppSettings.icons.models.administrationCaseReport,
    API: AppSettings.icons.models.trialApi,
    Capabilities: AppSettings.icons.models.institutionCapability,
    Configuration: AppSettings.icons.settings,
    Departments: AppSettings.icons.models.department,
    Details: AppSettings.icons.view,
    Files: AppSettings.icons.models.sourceDocument,
    Forms: AppSettings.icons.models.trialForm,
    Groups: AppSettings.icons.models.group,
    "Group Items": AppSettings.icons.models.trialGroupItem,
    "Institution Items": AppSettings.icons.models.trialInstitutionItem,
    "Institution Item Templates": AppSettings.icons.models.trialInstitutionItemTemplate,
    "Institutions & Roles": AppSettings.icons.models.personnelRole,
    Institutions: AppSettings.icons.models.institution,
    Items: AppSettings.icons.models.item,
    "Login & Security": AppSettings.icons.locked,
    Milestones: AppSettings.icons.models.trialMilestones,
    Notes: AppSettings.icons.models.note,
    OpenClinica: AppSettings.icons.externalLink,
    Participants: AppSettings.icons.models.participant,
    Permissions: AppSettings.icons.models.permission,
    Personnel: AppSettings.icons.models.personnel,
    "QA Tracker": AppSettings.icons.models.trialTracker,
    "Supporting Sites": AppSettings.icons.models.trialInstitutionSupportingSite,
    Tags: AppSettings.icons.models.institutionTag,
    Treatments: AppSettings.icons.models.trialTreatment,
    "Trial Items": AppSettings.icons.models.trialItem,
    Trials: AppSettings.icons.models.trial
};

/**
 * Uses an explicit link icon, then an exact-label mapping, then the generic lookup icon.
 */
export const getLayoutLinkIcon = (link: ILayoutLink): AppIconDefinition =>
    link.icon ?? (link.label ? iconsByLabel[link.label] : undefined) ?? AppSettings.icons.lookup;
